import { MEDIA_QUERIES } from "@constants"
import styled from "styled-components"
import { POST_BOOK_THEMES } from "../../PostBook.styles"

export const PostBookFooterNavDIV = styled.div`
  padding: var(--spacing--L) 0 var(--spacing--XL);

  .PostBookFooterNav--cards {
    display: flex;
    flex-wrap: wrap;
    gap: var(--spacing--S) var(--spacing--XS);
  }

  .PostBookFooterNav--card {
    align-items: center;
    background: var(--color--clay-200);
    border-radius: var(--border-radius--L);
    display: flex;
    flex: 0 0 100%;
    justify-content: space-between;
    gap: var(--spacing--M);
    overflow: hidden;
    padding: var(--spacing--S) var(--spacing--M);
    position: relative;

    ${MEDIA_QUERIES.L} {
      flex: 0 0 calc(50% - var(--spacing--XS) / 2);

      .has-single& {
        flex: 0 0 100%;
      }
    }

    h5 {
      text-wrap: balance;
    }

    .title,
    .IconButton {
      position: relative;
      z-index: 1;
    }

    .IconButton {
       flex: 0 0 var(--spacing--M);
       box-shadow: 0 0 0 1px var(--color--text-light);

      .Icon {
        background: var(--color--text-light);
      }
    }

    .gatsby-image-wrapper {
      left: 0;
      mask-image: linear-gradient(to right, rgba(0, 0, 0, 1) 25%, rgba(0, 0, 0, 0) 75%);
      max-width: 400px;
      opacity: 0;
      position: absolute !important;;
      top: 50%;
      translate: -21% -50%;
      transition: opacity 0.5s, translate 0.8s;
      width: 100%;
    }

    &.prev {
      h5,
      h6 {
        text-align: right;
      }
    }

    &.next {
      .gatsby-image-wrapper {
        left: auto;
        mask-image: linear-gradient(to left, rgba(0, 0, 0, 1) 25%, rgba(0, 0, 0, 0) 75%);
        right: 0;
        translate: 21% -50%;
      }
    }

    &:hover {
      transition: background-color 0.5s;

      h6 {
        opacity: 0.8;
      }

      .theme--${POST_BOOK_THEMES.ai} & {
        background-color: var(--PostBook--${POST_BOOK_THEMES.ai}--ACTIVE--background);
        
        h6,
        h5 {
          color: var(--PostBook--${POST_BOOK_THEMES.ai}--ACTIVE--headlines-color);
        }

        .IconButton {
          box-shadow: none;
          background: var(--PostBook--${POST_BOOK_THEMES.ai}--ACTIVE--headlines-color);

          .Icon {
            background: var(--PostBook--${POST_BOOK_THEMES.ai}--ACTIVE--background);
          }
        }
      }

      .theme--${POST_BOOK_THEMES["customer-service"]} & {
        background-color: var(--PostBook--${POST_BOOK_THEMES["customer-service"]}--ACTIVE--background);

        h6,
        h5 {
          color: var(--PostBook--${POST_BOOK_THEMES["customer-service"]}--ACTIVE--headlines-color);
        }

        .IconButton {
          box-shadow: none;
          background: var(--PostBook--${POST_BOOK_THEMES["customer-service"]}--ACTIVE--headlines-color);

          .Icon {
            background: var(--PostBook--${POST_BOOK_THEMES["customer-service"]}--ACTIVE--background);
          }
        }
      }

      .theme--${POST_BOOK_THEMES["knowledge-base"]} & {
        background-color: var(--PostBook--${POST_BOOK_THEMES["knowledge-base"]}--ACTIVE--background);

        h6,
        h5 {
          color: var(--PostBook--${POST_BOOK_THEMES["knowledge-base"]}--ACTIVE--headlines-color);
        }

        .IconButton {
          box-shadow: none;
          background: var(--PostBook--${POST_BOOK_THEMES["knowledge-base"]}--ACTIVE--headlines-color);

          .Icon {
            background: var(--PostBook--${POST_BOOK_THEMES["knowledge-base"]}--ACTIVE--background);
          }
        }
      }
      
      .gatsby-image-wrapper {
        opacity: 0.8;
        translate: -20% -50%;
      }
    }

    &.next:hover {
      .gatsby-image-wrapper {
        translate: 20% -50%;
      }
    }
  }
`
